import { useEffect } from 'react';
import { getOptionsEditorCfg } from '../../helpers/quokka_template_defaults_editor/templates_data_helpers';

// Registers a function to notify quokka about which optionsEditorCfg to use.
// This happens on "quokka mounted" event received.
//
// Note: In order to reduce the amount of times we register/unregister this function,
// We only refresh the notification function on templateId change.
// This means that if there are changes in templatesData, it is responsability of the user
// of this hook to change templateId so the last updated value of optionsEditorCfg is sent to quokka.
// i.e: set tempateId to null and then set the templateId back to its value
const useOptionsEditorCfgNotifier = (templateId, templatesData, quokkaIframeRef, propertyType) => {
  // On quokka mounted, send the options editor cfg
  useEffect(() => {
    if (!templateId) return;

    const sendBoOptionsEditorCfg = (e) => {
      if (e.data[0] !== 'quokka-options-editor-mounted') return;

      if (!quokkaIframeRef.current) {
        // eslint-disable-next-line no-console
        console.error('There was a problem mounting quokka options editor in buildout iframe ref');
        return;
      }

      const optionsEditorCfg = getOptionsEditorCfg(templatesData, templateId, propertyType);

      quokkaIframeRef.current.contentWindow.postMessage(['set-bo-options-editor-cfg', {
        optionsEditorCfg
      }], '*');
    };

    window.addEventListener('message', sendBoOptionsEditorCfg);

    return () => window.removeEventListener('message', sendBoOptionsEditorCfg);
  }, [templateId, propertyType]);
};

export default useOptionsEditorCfgNotifier;